import { render } from "./UserCommissionPackageselector.vue?vue&type=template&id=4aad82da"
import script from "./UserCommissionPackageselector.vue?vue&type=script&lang=js"
export * from "./UserCommissionPackageselector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__